import { baseGeospatial } from "../../../api/base/baseUrl";

const BASE_URL = "/api/v1/vehicle-has-province";

export async function getVehicleHasProvinceByVehicleIdRequest(vehicleId) {
  const response = await baseGeospatial.get(
    `${BASE_URL}/get-by-vehicleid/${vehicleId}`,
  );
  return response.data;
}

export async function createVehicleHasProvinceRequest(payload) {
  const response = await baseGeospatial.post(BASE_URL, payload);
  return response.data;
}

export async function updateVehicleHasProvinceRequest(payload) {
  const response = await baseGeospatial.put(`${BASE_URL}/update`, payload);
  return response.data;
}
